;(function(global, $) {
  /* @if env='production' **
  var omsHost = 'http://operation.huariot.com/'
  var appHost = 'https://app.huariot.com'
  /* @endif */
  /* @if env!='production' **
  var omsHost = 'http://test.oms.huariot.com'
  var appHost = 'http://test.app.huariot.com'
  /* @endif */
  
  var newAPI = omsHost + '/api/v1/news/'
  var staffAPI = omsHost + '/api/v1/staff-style-list/'
  var fourDataAPI = appHost + '/yx-order-service/api/v1/social/contribution/'
  function getNews(condition, callback) {
    var data = $.extend({}, condition)
    return Fetch({
      url: newAPI,
      data: data
    }, callback, false)
  }

  function getNewsDetail(id, callback) {
    return Fetch({
      url: newAPI + id + '/'
    }, callback, false)
  }

  function getStaff(condition, callback) {
    var data = $.extend({}, condition)
    return Fetch({
      url: staffAPI,
      data: data
    }, callback, false)
  }

  function getFourData(condition, callback) {
    return Fetch({
      url: fourDataAPI      
    }, callback, false)
  }

  global['API'] = {
    getNews: getNews,
    getNewsDetail: getNewsDetail,
    getStaff: getStaff,
    getFourData: getFourData
  }
  
}(window, window.jQuery))
